import type { Book } from "../api/types";
import { progressText } from "../lib/stage";
import { AlertIcon, SpinnerIcon } from "./Icon";

type ChipBook = Pick<
  Book,
  "status" | "stage" | "chapters_done" | "chapters_total" | "reading_minutes" | "error_message"
>;

export default function StatusChip({ book }: { book: ChipBook }) {
  const label = progressText(book);

  if (book.status === "completed") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-soft px-2.5 py-1 text-xs font-medium text-accent-strong">
        {label}
      </span>
    );
  }

  if (book.status === "failed") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-danger-surface px-2.5 py-1 text-xs font-medium text-danger">
        <AlertIcon width={12} height={12} />
        {book.error_message ? "Failed" : label}
      </span>
    );
  }

  if (book.status === "canceled") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full border border-border px-2.5 py-1 text-xs font-medium text-muted">
        {label}
      </span>
    );
  }

  // queued | processing
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-surface-raised px-2.5 py-1 text-xs font-medium text-muted ring-1 ring-inset ring-border">
      <SpinnerIcon width={12} height={12} className="text-accent" />
      {label}
    </span>
  );
}
